import { useAppStateStore } from '@/features/application'
import { loadToken } from '@/features/services/profil/AdministrationService'
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useHabilitationsAdminViewStore = defineStore('habilitations-admin-container', () => {
  const token = ref<string>()
  const id = ref<ReturnType<typeof setTimeout>>()
  const isRunning = ref<boolean>(false)

  const appState = useAppStateStore()

  function start() {
    isRunning.value = true
    return chargeToken()
  }

  function stop() {
    $reset()
  }

  function $reset() {
    if (id.value) clearTimeout(id.value)
    id.value = undefined
    token.value = undefined
    isRunning.value = false
  }

  async function chargeToken() {
    token.value = await loadToken()
    id.value = setTimeout(chargeToken, 30 * 60 * 1000)
  }

  watch(
    () => appState.utilisateur?.emailAffichage,
    async () => {
      const estAutorisé = appState.autoriseEcriture('Administration')
      if (isRunning.value === false || estAutorisé === false) {
        $reset()
        return
      }
      await chargeToken()
    },
  )

  return { token, start, stop }
})
